

const data = {
    modelInstance: {},
    actionInstance: {}
};

export const setData = (key, value) => {

    data[key] = value;

}

export const getData = (key) => {
    if (key) {
        return data[key]
    }

    return data;
}

